import { render } from "./TranslationHistory.vue?vue&type=template&id=62a16292&scoped=true"
import script from "./TranslationHistory.vue?vue&type=script&lang=js"
export * from "./TranslationHistory.vue?vue&type=script&lang=js"

import "./TranslationHistory.vue?vue&type=style&index=0&id=62a16292&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a16292"]])

export default __exports__